interface EtapaAutorizacaoEtapa2Props {
  autorizacaoTermo: boolean;
  onChange: (valor: boolean) => void;
}

export default function EtapaAutorizacaoEtapa2({ autorizacaoTermo, onChange }: EtapaAutorizacaoEtapa2Props) {
  return (
    <>
      <h2 className="mb-6 text-2xl font-bold text-gray-800">Quase lá!</h2>
      <p className="mb-6 text-gray-600">
        Pra finalizar seu cadastro de admissão, precisamos da sua concordância com o termo abaixo.
      </p>
      <button
        type="button"
        onClick={() => onChange(!autorizacaoTermo)}
        className={`relative w-full rounded-xl border-2 p-4 text-left transition-all duration-200 ${
          autorizacaoTermo
            ? 'border-indigo-600 bg-indigo-50/50 shadow-sm ring-1 ring-indigo-600'
            : 'border-gray-100 hover:border-indigo-200 hover:bg-gray-50'
        }`}
      >
        <div className="flex items-start gap-4">
          <div
            className={`mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full border-2 transition-colors ${
              autorizacaoTermo ? 'border-indigo-600 bg-indigo-600 text-white' : 'border-gray-300'
            }`}
          >
            {autorizacaoTermo && <div className="h-2 w-2 rounded-full bg-white" />}
          </div>
          <span className="font-medium text-gray-700">
            Declaro que as informações fornecidas são verdadeiras e autorizo a Raro Labs a utilizá-las para fins de
            admissão e gestão da minha relação de trabalho.
          </span>
        </div>
      </button>
    </>
  );
}
